import type { FC } from "react";
import React from "react";
import classNames from "classnames";
import styles from "./BettingWidget.module.scss";
import Script from "next/script";
import type { BettingWidget as BettingWidgetComponent } from "@motain/xpa-proto-files-web/lib/types/betting_widget";

const WIDGET_SCRIPT_URL =
  "https://embed.onefootball.com/widget/onefootball-cweb.js";

export const BettingWidget: FC<BettingWidgetComponent> = (props) => {
  const { title } = props;
  const timestamp = Date.now();

  return (
    <section>
      <header className={styles.header}>
        <p className={classNames("title-7-bold", styles.title)}>{title}</p>
      </header>
      <div
        className={classNames(
          styles.container,
          "of-widget of-widget-eyJwIjoib25lZm9vdGJhbGwtY3dlYiJ9",
        )}
      />
      <Script
        // we pass this random query param to force the script to reload
        src={`${WIDGET_SCRIPT_URL}?random=${timestamp}`}
        strategy="lazyOnload"
      />
    </section>
  );
};
